<div class="modal-header">
    <div class="modal-title" id="modal-basic-title">State Fraud Notices</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body mb-3">
    <div class="row ps-3 pe-3">
        <div class="col-12 col-lg-6 pe-lg-5">
            <h5>To Arizona Claimants</h5>
            <p>
                For your protection Arizona law requires the following statement to appear on this form. Any person who knowingly presents a false or fraudulent claim for payment
                of a loss is subject to criminal and civil penalties.
            </p>
            <h5>To Claimants in Arkansas, Louisiana, Maryland and Texas</h5>
            <p>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or (in AR, LA, or MD) knowingly presents false information in an
                application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
            </p>

            <h5>To California Claimants</h5>
            <p>
                For your protection California law requires the following to appear on this form: Any person who knowingly presents false or fraudulent claim for the payment of a
                loss is guilty of a crime and may be subject to fines and confinement in state prison.
            </p>

            <h5>To Colorado Claimants</h5>
            <p>
                It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to
                defraud the company. Penalties may include imprisonment, fines, denial of insurance, and civil damages. Any insurance company or agent of an insurance company who
                knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the
                policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado division of insurance within the
                department of regulatory agencies.
            </p>

            <h5>To Claimants in Delaware, Idaho and Indiana</h5>
            <p>
                Any person who knowingly, and with intent to injure, defraud or deceive any insurer, files a statement of claim containing any false, incomplete or misleading
                information is guilty of a felony.
            </p>

            <h5>To Florida Claimants</h5>
            <p>
                Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim containing any false, incomplete, or misleading
                information is guilty of a felony of the third degree.
            </p>

            <h5>To Kentucky Claimants</h5>
            <p>
                Any person who knowingly and with intent to defraud any insurance company or other person files a statement of claim containing any materially false information or
                conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.
            </p>

            <h5>To Minnesota Claimants</h5>
            <p>A person who files a claim with intent to defraud or helps commit a fraud against an insurer is guilty of a crime.</p>
        </div>
        <div class="col-12 col-lg-6 ps-lg-5">
            <h5>To New Hampshire Claimants</h5>
            <p>
                Any person who, with a purpose to injure, defraud or deceive any insurance company, files a statement of claim containing any false, incomplete or misleading
                information is subject to prosecution and punishment for insurance fraud, as provided in RSA 638:20.
            </p>

            <h5>To New Jersey Claimants</h5>
            <p>Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.</p>

            <h5>To New Mexico Claimants</h5>
            <p>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for
                insurance is guilty of a crime and may be subject to civil fines and criminal penalties.
            </p>

            <h5>To New York Claimants</h5>
            <p>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any
                materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which
                is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.
            </p>

            <h5>To Ohio Claimants</h5>
            <p>
                Any person who, with intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or
                deceptive statement is guilty of insurance fraud.
            </p>

            <h5>To Oklahoma Claimants</h5>
            <p>
                WARNING: Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the proceeds of an insurance policy containing any
                false, incomplete or misleading information is guilty of a felony.
            </p>

            <h5>To Oregon Claimants</h5>
            <p>
                Any person who knowingly and with the intent to defraud any insurer provides false or misleading information concerning any fact material to a risk to be insured or
                to a claim for loss or benefits may be guilty of a crime.
            </p>

            <h5>To Pennsylvania Claimants</h5>
            <p>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any
                materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which
                is a crime and subjects such person to criminal and civil penalties.
            </p>

            <h5>To Claimants in Virginia, Washington, and any State not listed above</h5>
            <p>
                It is a crime to knowingly provide false, incomplete, or misleading information to an insurance company for the purpose of defrauding the company. Penalties include
                imprisonment, fines or a denial or insurance benefits.
            </p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close('Close click')">Close</button>
</div>
